import { NormalInfoWrapper } from "../../../tasks/styles";

type ApplicantProps = {
  data: any;
}

interface Detail {
  label: string,
  value: any,
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1
  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null){
      lastValidRow = i;
    }
  }
  return [lastValidRow]
}

function formatBirthDate(birthDate: string | Date | null | undefined): string | null {
  if (birthDate == null) return null;
  const date = birthDate instanceof Date ? birthDate : new Date(birthDate);
  return date.toISOString().split('T')[0];
}

export const ApplicantRow = ({ data }: ApplicantProps) => {

  const addressInformation = data?.agentApiApplication?.applicant?.addressInformation;
  const address = addressInformation
    ? `${addressInformation.typeOfAddress}, ${addressInformation.streetName}, ${addressInformation.postalCode}, ${addressInformation.city}`
    : "Address not available";

  const applicantDetails = [
    { label: "Age", value: data?.integrations?.statistica?.ownExperience?.variables?.age },
    { label: "Birth date", value: formatBirthDate(data?.agentApiApplication?.applicant?.birthDate) },
    { label: "Address", value: address },
    { label: "Marital status", value: data?.integrations?.statistica?.ownExperience?.variables?.maritalStatus },
    { label: "Children (under 18)", value: data?.integrations?.statistica?.ownExperience?.variables?.numberOfChildrenBelow18 },
    { label: "Employment status", value: data?.integrations?.statistica?.ownExperience?.variables?.employment_type },
    { label: "Contract type", value: data?.integrations?.statistica?.ownExperience?.variables?.employment_contractType },
    { label: "Employer since", value: data?.integrations?.statistica?.ownExperience?.variables?.employment_fromYear},
    { label: "Profession", value: data?.integrations?.statistica?.ownExperience?.variables?.employment_professionType},
  ].filter(detail => detail.value != null && detail.value !== "Undefined")
  const lastIndexes = getIndexOfLastRow(applicantDetails)
  return (
    <>
      <NormalInfoWrapper $header>Applicant Details</NormalInfoWrapper>
      {applicantDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return
        return (
          <NormalInfoWrapper key={`applicant-${index}-${detail.label}`} $isLast={lastIndexes.includes(index)}>
            <div>{detail.label}</div>
            <div style={{ textAlign: "end"}}>{detail.value}</div>
          </NormalInfoWrapper>
        )
      })
      }
    </>
  )
}